import { Component, EventEmitter, Input, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromStore from '../store';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  userData$: Observable<any>;
  isAuthenticated: boolean;
  constructor(private store: Store<fromStore.SecurityState>, private oidcSecurityService: OidcSecurityService) {}

  ngOnInit(): void {
    this.userData$ = this.store.pipe(select(fromStore.getUserData));

    this.oidcSecurityService.isAuthenticated$.subscribe(authenticated => {
      this.isAuthenticated = authenticated;
    });
  }

  logout() {
    this.store.dispatch(new fromStore.SetUserData(null));
    this.oidcSecurityService.logoff();
  }
}
